export default __webpack_public_path__ + "img/dvUmCjBE.0acb7739.svg";